module.exports = __webpack_public_path__ + "img/partners_long.ddf69e85.png";